import {EventEmitter, Injectable} from '@angular/core';
import {Stage} from 'konva/lib/Stage';
import {Vector2d} from 'konva/lib/types';
import {
  Edge,
    ICanvasObject,
    IConnectorsEdges,
    IFullGraphData,
    IGraphData,
    ILayerData,
    IStorageSettings,
    ITagretsNodes,
    TGraphType,
    TStoredSetting,
    IAdComponentData,
    IGraphNode,
    IAttachmentsData,
} from '../models/graph-kn.model-interfaces';
import {Arrow} from 'konva/lib/shapes/Arrow';
import {graphStoreConfig, LONG_TAP_DURATION, SETTING_STORAGE} from '../models/graph-kn.cm.model-const';
import {Group} from 'konva/lib/Group';
import {Edges, Nodes} from '../../../models/graph.model';
import {BehaviorSubject, from, map, Observable, of, Subject, switchMap, take, tap} from 'rxjs';
import {
    CONTRACT_LAYER_ID,
    DagreNodesOnlySettings,
    IKnGraphSettings,
    IKnUIOptions,
    INodeChangeEvent,
    IStageSettings,
    TContractGraphType,
    TLayerIDs
} from '../models/graph-kn.cm-api-models';
import {CompanyContractModel, ContractStepModel} from '../../../models/contract.model';
import {NgxIndexedDBService} from 'ngx-indexed-db';
import {setIndexDBversion} from '../../../app.module';
import { MemberModel } from '../../../models/user.model';
import { DagreNodesOnlyLayout } from './layout/dagreNodesOnly';
import { Path } from 'konva/lib/shapes/Path';
import { SafeUrl } from '@angular/platform-browser';

@Injectable({
    providedIn: 'root'
})

export class GraphKnDataService {
    public graphType!: TGraphType;
    public graphStage!: Stage;
    public stageSettings!: IStageSettings;
    public graphUISetting!: Map<TLayerIDs, IKnUIOptions>
    public layoutDagreSettings: Map<TLayerIDs, DagreNodesOnlySettings> = new Map()
    public graphSettingsMap: Map<TLayerIDs, IKnGraphSettings> = new Map()
    public layoutDagre: DagreNodesOnlyLayout = new DagreNodesOnlyLayout();
    public layoutModel!: TContractGraphType
    public contractGD: Map<string, IFullGraphData> = new Map([]);
    public contractNodes: Map<string, ITagretsNodes[]> = new Map([])
    public contractsEdges: IConnectorsEdges[] = [];

    public businessProcessGD: IGraphData = {
        activeStepId: '',
        nodes: [],
        edges: []
    }
    public businessProcessNodes: ITagretsNodes[] = []
    public businessProcessEdges: IConnectorsEdges[] = [];

    public layersMap: Map<string, ILayerData> = new Map([])

    public linkPath!: Path;
    public linkEdge!: Arrow;
    public contractConnectors: {
        arrow: Arrow,
        fromId: string,
        toId: string,
        fromLayerID: string,
        toLayerID: string
    }[] = [];

    public defaultDagreSetting: DagreNodesOnlySettings = {
        marginX: 2,
        ranker: 'longest-path',
        heigt: window.innerHeight * 0.90,
    }
    public nodeWidth!: number
    public nodeHeight!: number
    public selectedNodeGroupId!: string;
    public selectedNodeGroup: Group|undefined = undefined;

    public canvasObjectsMap: Map<string, ICanvasObject> = new Map([])
    public dragStopped: boolean = false;
    public dragStartPosition: Vector2d = {x: 0, y: 0}
    public lastTouchPostion: Vector2d = {x: 0, y: 0}
    public lastCenter: Vector2d | null = null;
    public lastDist: number = 0;
    public longTapData = {start: 0, end: 0, duration: LONG_TAP_DURATION}
    public activeStepId: string = ''

    public emitNodeEvent: EventEmitter<INodeChangeEvent> = new EventEmitter<INodeChangeEvent>();
    public selectedBPStep: EventEmitter<Node | undefined> = new EventEmitter<Node | undefined>();

    public generateGraphDataBP$: Subject<{ nodes: Node[], edges: Edge[] } | {}> = new Subject()
    public generateTaskGraphData$: Subject<{ nodes: IGraphNode[], edges: Edge[], activeStepId: string }> = new Subject()
    public generateGraphDataSubContract$: Subject<{
         nodes: IGraphNode[],
        edges: Edge[],
        state: string,
        parent_contract_guid: string
    }> = new Subject()
    public generateGraphDataContract$: Subject<{
        nodes: IGraphNode[],
        edges: Edge[],
        state: string,
        projects: CompanyContractModel[],
        redraw: boolean,
        data?: { guid: string }
    }> = new Subject()
    public BsUsersData:BehaviorSubject<MemberModel[]|{}> = new BehaviorSubject({})
    public BsAvatarData:BehaviorSubject<Map<string,{img:SafeUrl}>> = new BehaviorSubject(new Map())
    public subOnNewSteps$: Subject<{ step: ContractStepModel | null, id: string | null, add: boolean }> = new Subject()
    public subOnStepsOrderChanged$: Subject<{ guid: string, sort_index: number, name?:string }[]> = new Subject()
    public subSettingsUploaded$: Subject<{ contractGraphType: TContractGraphType }> = new Subject()
    public subGraphSettingsChangesd$: Subject<[TLayerIDs, DagreNodesOnlySettings ]> = new Subject()
    public subToolBarOpen: Subject<IAdComponentData> = new Subject()
    public subUserListOpen: Subject<IAdComponentData> = new Subject()
    public subAttachementsListOpen: Subject<IAttachmentsData> = new Subject()
    public subGraphIsLoading: Subject<boolean> = new Subject()
    public users: MemberModel[] = []
    public loadingIds: string[] = []
    public contractStatus!: string;
    public lastContractStepId: string = ''
    public topNodeYpos!: number;
    nodeCountPerStage!: number;
    dragGroupId!: string;
    dragGroupIndex!: number;

    constructor(
        private dbService: NgxIndexedDBService,
    ) {
    }

    resetValues(resetUI = true) {
        this.graphType = CONTRACT_LAYER_ID;
        this.nodeWidth = 0;
        this.nodeHeight = 0;
        this.contractsEdges = [];
        this.contractGD.clear();
        this.contractNodes.clear();
        this.activeStepId = '';
        this.businessProcessGD = {
            activeStepId: '',
            nodes: [],
            edges: []
        }
        this.contractsEdges = [];
        this.businessProcessNodes = []
        this.businessProcessEdges = [];
        this.contractConnectors = [];
        this.layersMap.clear();
        resetUI ? this.graphUISetting.clear() : null;
    }

    updateSettings(): Observable<TContractGraphType> {
        let storeKey: TStoredSetting = 'contract_graph_type'
        let settingsContractGraph = this.layoutDagreSettings.get('contractLayer')
        return this.dbService.getAllObjectStoreNames()
            .pipe(
                take(1),
                switchMap(stores => stores.includes(SETTING_STORAGE) ? of(true) : this.createSettingStore()),
                switchMap(res => this.dbService.getByID(SETTING_STORAGE, storeKey)),
                map((graphType) => ((graphType as IStorageSettings)?.setting_value || 'line') as TContractGraphType),
                tap(graphType => settingsContractGraph ? settingsContractGraph.layoutModel = graphType : null),
                tap(graphType => settingsContractGraph?.layoutModel ? this.subSettingsUploaded$.next({contractGraphType: graphType}) : null),
            )
    }

    createSettingStore(): Observable<boolean> {
        return this.dbService.getDatabaseVersion().pipe(
            tap(indexDBVersion => setIndexDBversion(+indexDBVersion)),
            switchMap(() => from(this.dbService.createObjectStore(graphStoreConfig))),
            map(() => true)
        )
    }
}